import { ComponentApiRecord, StaticComponentAnalyzerResult } from "./types.js"

export async function analyzeTypescriptApi(
  staticComponentsResult: StaticComponentAnalyzerResult,
): Promise<Record<string, ComponentApiRecord>> {
  return staticComponentsResult.typescriptApiByComponentKey
}
